import { computed } from "vue";

export function useYearMonthPairs(samples) {
    return computed(() => {
        const pairs = [];

        if (!samples?.value) {
            return pairs;
        }

        for (const year of Object.keys(samples.value)) {
            for (let month = 0; month < 12; month++) {
                pairs.push({
                    year: Number(year),
                    month
                });
            }
        }

        return pairs;
    });
}